import {defineNuxtPlugin} from '#app';
import type {FeatureFlagId} from '../feature-flag.types';
import {useFeatureFlagsStore} from '../store/feature-flags.store';

export default defineNuxtPlugin(() => {
    const store = useFeatureFlagsStore();

    return {
        provide: {
            ff: (flagId: FeatureFlagId): boolean => store.featureFlags[flagId] ?? false,
        },
    };
});
